export default __webpack_public_path__ + "233c18debdf7d60f33d946b13bb29932.svg";